import { SVGProps } from "react";

const STIBluetooth = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Bluetooth" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#0082FC" /><path fill="none" stroke="#fff" strokeWidth={33} d="M151 154l190 191-87 90V78l87 93-190 192" /></svg>;

export { STIBluetooth };